import { Service, signal } from '@angular/core';

interface DoorSelection {
  projectId: string;
  doorIds: string[];
}

/**
 * Holds the door ids selected on the door-setup page so the hardware page can scope its data.
 * Kept in memory only — the selection does not survive a page refresh.
 */
@Service()
export class DoorSelectionService {
  private selection = signal<DoorSelection | null>(null);

  setSelection(projectId: string, doorIds: string[]): void {
    this.selection.set({ projectId, doorIds });
  }

  getDoorIds(projectId: string): string[] {
    const selection = this.selection();
    return selection?.projectId === projectId ? selection.doorIds : [];
  }
}
